/**
 * Valid benefit field names for Cancer LOC
 *
 * Used to filter out fields that don't belong to Cancer benefits when saving to API.
 * These fields represent the API structure (nested objects created by transforms).
 */

export const CANCER_VALID_FIELDS = new Set([
  "objectType",
  // Nested benefit objects (created by transform, not flat grid fields)
  "diagnosisBenefit",
  "initialDiagnosisWaitingPeriod",
  "radiationTherapyChemo",
  "bloodPlasmaPlatelets",
  "hospice",
  "hospitalConfinementInitial",
  "icuConfinementInitial",
  "skinCancer",
  "surgicalBenefit",
  "wellnessBenefit",
  "preExistingCondition",
  // Simple enum fields (not nested)
  "portability",
  "waiverOfPremium",
  "annualOpenEnrollment",
  // Flat fields
  "benefitClassAvailability",
  "extended",
]);
